import axios from "axios";
import "aws-sdk/dist/aws-sdk";

import { config } from "../configs";
import { getSessionToken } from "./getToken";

const getOrgCustomer = async (orgId, customerId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();

      const url = `${config.baseURL}/organizations/current/customers/${customerId}`;
      const { status, data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      if (status === 200) resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateOrgCustomerDetails = async (orgId, customerId, requestBody) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}`;
      const { status } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: requestBody,
      });
      if (status === 204) resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

const postNewCustomerAddress = async (orgId, customerId, requestBody) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/addresses`;
      const { status } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: requestBody,
      });
      if (status === 200) resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

const patchCustomerAddress = async (
  orgId,
  customerId,
  addressId,
  requestBody
) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/addresses/${addressId}`;
      const { status } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: requestBody,
      });
      if (status === 204) resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

const removeCustomerAddress = async (orgId, customerId, addressId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/addresses/${addressId}`;
      const { status } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      if (status === 204) resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  getOrgCustomer,
  updateOrgCustomerDetails,
  postNewCustomerAddress,
  patchCustomerAddress,
  removeCustomerAddress,
};
